import { render, staticRenderFns } from "./add-doc-dialog.vue?vue&type=template&id=70627054&scoped=true"
import script from "./add-doc-dialog.vue?vue&type=script&lang=js"
export * from "./add-doc-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70627054",
  null
  
)

export default component.exports